(() => {
  const form = document.querySelector('[data-moser-password-newsletter]');
  if (!form || form.dataset.passwordInitialized === 'true') return;
  form.dataset.passwordInitialized = 'true';
  const shell = form.closest('[data-password-newsletter-shell]');
  const email = form.querySelector('[name="EMAIL"]');
  const consent = form.querySelector('[name="OPT_IN"]');
  const button = form.querySelector('button[type="submit"]');
  const label = form.querySelector('[data-password-submit-label]');
  const status = form.querySelector('[data-password-newsletter-status]');
  const success = shell.querySelector('#success-message');
  const error = shell.querySelector('#error-message');
  const transport = document.querySelector('[data-password-brevo-script]');
  const captchaScript = document.querySelector('[data-password-turnstile-script]');
  const idleLabel = label.textContent;
  let ready = false;
  let failed = false;
  let responseTimer = null;

  const show = (state, message) => {
    form.dataset.state = state;
    form.setAttribute('aria-busy', state === 'submitting' ? 'true' : 'false');
    status.textContent = message;
    label.textContent = state === 'submitting' ? 'Wird gesendet …' : idleLabel;
    if (state === 'submitting' && responseTimer === null) {
      responseTimer = setTimeout(() => {
        responseTimer = null;
        if (form.dataset.state === 'submitting') {
          show('error', 'Die Übermittlung konnte nicht bestätigt werden. Bitte lade die Seite neu, bevor du es erneut versuchst.');
        }
      }, 30000);
    } else if (state !== 'submitting') {
      clearTimeout(responseTimer);
      responseTimer = null;
    }
  };
  const unavailable = () => {
    failed = true;
    button.disabled = true;
    show('error', 'Die Anmeldung ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.');
  };
  const synchronize = () => {
    if (failed) return;
    if (success.classList.contains('sib-form-message-panel--active')) {
      show('doi_sent', 'Fast geschafft. Schau jetzt in dein Postfach und bestätige deine Anmeldung.');
    } else if (error.classList.contains('sib-form-message-panel--active')) {
      show('error', 'Deine Anmeldung konnte nicht gespeichert werden. Bitte versuche es erneut.');
    } else if (ready && button.disabled) {
      show('submitting', 'Deine Anmeldung wird gesendet …');
    }
  };

  form.addEventListener('submit', event => {
    const block = () => {
      event.preventDefault();
      event.stopImmediatePropagation();
    };
    if (!ready || failed) {
      block();
      show('error', 'Die Anmeldung ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.');
      return;
    }
    if (button.disabled || form.dataset.state === 'submitting') {
      block();
      return;
    }
    if (!email.checkValidity()) {
      block();
      email.setAttribute('aria-invalid', 'true');
      show('invalid_email', 'Bitte gib eine gültige E-Mail-Adresse ein.');
      email.focus();
      return;
    }
    email.removeAttribute('aria-invalid');
    if (!consent.checked) {
      block();
      consent.setAttribute('aria-invalid', 'true');
      show('consent_missing', 'Bitte bestätige, dass du den MOSER-Newsletter erhalten möchtest.');
      consent.focus();
      return;
    }
    consent.removeAttribute('aria-invalid');
    let captchaResponse = '';
    try {
      captchaResponse = window.turnstile?.getResponse() || '';
    } catch (_) {
      captchaResponse = '';
    }
    if (!captchaResponse) {
      block();
      show('captcha_missing', 'Bitte schließe die Sicherheitsprüfung ab und versuche es erneut.');
      return;
    }
    success.classList.remove('sib-form-message-panel--active');
    error.classList.remove('sib-form-message-panel--active');
    queueMicrotask(synchronize);
  }, true);

  const observer = new MutationObserver(synchronize);
  observer.observe(button, { attributes: true, attributeFilter: ['disabled', 'class'] });
  observer.observe(success, { attributes: true, attributeFilter: ['class'] });
  observer.observe(error, { attributes: true, attributeFilter: ['class'] });
  transport.addEventListener('load', () => {
    ready = true;
    if (!failed) {
      button.disabled = false;
      show('default', '');
    }
  }, { once: true });
  transport.addEventListener('error', unavailable, { once: true });
  captchaScript.addEventListener('error', unavailable, { once: true });
  show('loading', 'Das Formular wird geladen …');
})();
